import React from 'react';
import { DesktopWidgets } from '../../components/DesktopWidgets/DesktopWidgets';
import { TabSlug } from '../../types';

export const Income = () => {
  return <DesktopWidgets tab={TabSlug.Income} />;
};
